/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=1738b5d2"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=1738b5d2&lang=stylus"

import exportComponent from "C:\\Users\\RedFlag\\Desktop\\code\\qms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__